import { convertSvgToBase64 } from 'src/core/utils/fileUtil';
import followingIcon from 'src/images/following.svg';

const IMAGE_DIMENSION = 20;

export default () => (
  <img
    src={convertSvgToBase64(followingIcon)}
    width={IMAGE_DIMENSION}
    height={IMAGE_DIMENSION}
    style={{ position: 'relative', top: '4px' }}
  />
);
